import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Checkbox } from 'semantic-ui-react';

const toggleToken = (currentValue, token, checked) => {
  const current = Array.isArray(currentValue) ? currentValue : [];
  if (checked) {
    return current.includes(token) ? current : [...current, token];
  }
  return current.filter(t => t !== token);
};

const ApprovalConfigSection = ({
  discountPercentageValue,
  bonusSubscriptionTypeValue,
  showBonusSubscription,
}) => {
  const isHigherDiscountEnabled = Number(discountPercentageValue) > 0;

  const isBonusSubscriptionEnabled =
    bonusSubscriptionTypeValue && bonusSubscriptionTypeValue !== 'NONE';

  return (
    <Field
      name="approval_requirements"
      component={({ input }) => (
        <div style={{ marginTop: '1em' }}>
          <strong>Approval Configuration</strong>
          <p
            style={{
              color: '#666',
              marginTop: '0.25em',
              marginBottom: '0.75em',
            }}
          >
            This config will be used for manual invoice creation by Telesales /
            Sales
          </p>

          <div
            style={{
              border: '1px solid #ddd',
              borderRadius: '4px',
              padding: '0.75em 1em',
              marginBottom: showBonusSubscription ? '0.5em' : 0,
            }}
          >
            <Checkbox
              label="Allow Higher Discount"
              checked={
                Array.isArray(input.value) &&
                input.value.includes('HIGHER_DISCOUNT')
              }
              disabled={!isHigherDiscountEnabled}
              onChange={(e, { checked }) =>
                input.onChange(
                  toggleToken(input.value, 'HIGHER_DISCOUNT', checked)
                )
              }
            />
            <div
              style={{
                color: '#666',
                fontSize: '0.875em',
                marginTop: '0.25em',
                marginLeft: '1.75em',
              }}
            >
              Requires approval for the configured discount percentage
            </div>
          </div>

          {showBonusSubscription && (
            <div
              style={{
                border: '1px solid #ddd',
                borderRadius: '4px',
                padding: '0.75em 1em',
              }}
            >
              <Checkbox
                label="Implement Extra Subscription"
                checked={
                  Array.isArray(input.value) &&
                  input.value.includes('BONUS_SUBSCRIPTION')
                }
                disabled={!isBonusSubscriptionEnabled}
                onChange={(e, { checked }) =>
                  input.onChange(
                    toggleToken(input.value, 'BONUS_SUBSCRIPTION', checked)
                  )
                }
              />
              <div
                style={{
                  color: '#666',
                  fontSize: '0.875em',
                  marginTop: '0.25em',
                  marginLeft: '1.75em',
                }}
              >
                Requires approval for the extra subscription period
              </div>
            </div>
          )}
        </div>
      )}
    />
  );
};

ApprovalConfigSection.propTypes = {
  discountPercentageValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  bonusSubscriptionTypeValue: PropTypes.string,
  showBonusSubscription: PropTypes.bool,
};

ApprovalConfigSection.defaultProps = {
  discountPercentageValue: null,
  bonusSubscriptionTypeValue: 'NONE',
  showBonusSubscription: true,
};

export default ApprovalConfigSection;
